// extracted by mini-css-extract-plugin
module.exports = {"containerPengumuman":"Pengumuman_containerPengumuman__SeXMq","pengumumanItem":"Pengumuman_pengumumanItem__034H0","timePengumuman":"Pengumuman_timePengumuman__8oBA2"};